var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotcomm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_548_2310)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 27.5,
    r: 27.5,
    fill: "#FCEAC4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_548_2310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.7385 32.507L35.948 40.0655C35.5423 40.7059 34.8662 41.1251 34.1122 41.2023L25.8045 42.0638C25.5864 42.0866 25.3824 42.1832 25.2272 42.3385L24.8624 42.7032C24.7383 42.8274 24.5349 42.82 24.4202 42.6872L20.6162 38.2876L23.3284 37.1794L33.7709 35.4159L38.0414 30.498C38.4435 30.0344 39.0508 29.8397 39.6224 29.9457C39.8435 29.9864 40.0603 30.0723 40.2577 30.2061C40.3493 30.2676 40.4323 30.337 40.5074 30.4122C41.0547 30.9595 41.1677 31.8288 40.7385 32.507Z",
    fill: "#FFE5C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7385 32.5071L35.948 40.0656C35.5423 40.706 34.8662 41.1252 34.1122 41.2024L25.8045 42.0638C25.5864 42.0867 25.3824 42.1833 25.2272 42.3386L24.8624 42.7034C24.7383 42.8274 24.5349 42.8201 24.4202 42.6874L23.3821 41.4872L23.3992 41.47C23.865 41.0042 24.4767 40.7138 25.132 40.6458L32.7643 39.8545C33.5183 39.7765 34.1944 39.3573 34.6001 38.717L39.3907 31.1584C39.6239 30.7892 39.6976 30.3628 39.6268 29.963C39.6253 29.9566 39.6239 29.9515 39.6224 29.9458C39.8435 29.9866 40.0603 30.0725 40.2577 30.2062C40.3493 30.2678 40.4323 30.3371 40.5074 30.4123C41.0547 30.9596 41.1677 31.8289 40.7385 32.5071Z",
    fill: "#FED2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0786 36.371C34.0786 36.8218 33.8954 37.2295 33.6006 37.5257C33.3045 37.8205 32.8966 38.0037 32.4459 38.0037H26.2531L21.0977 38.8443L20.6162 38.2877L20.3085 37.9319C20.1961 37.802 20.2145 37.6047 20.3489 37.4978L24.202 34.4314C25.7831 33.1737 28.0574 33.3053 29.4833 34.7376H32.4459C33.3474 34.7377 34.0786 35.4689 34.0786 36.371Z",
    fill: "#FFE5C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2528 37.927V38.0043L32.4457 38.004C32.8967 38.0043 33.3049 37.8212 33.6006 37.5255C33.8959 37.2302 34.0787 36.8224 34.0787 36.371C34.0787 36.0948 34.0102 35.8351 33.8894 35.6072C33.8128 35.7517 33.7153 35.883 33.6006 35.9977C33.3049 36.2934 32.8967 36.4758 32.4457 36.4762L27.7039 36.476C26.9025 36.4759 26.2528 37.1255 26.2528 37.927Z",
    fill: "#FED2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3488 37.4988L24.202 34.4317C25.7831 33.1739 28.0575 33.3056 29.4833 34.7379H32.4459C33.3474 34.7379 34.0786 35.4691 34.0786 36.3712C34.0786 36.8219 33.8954 37.2297 33.6007 37.5259C33.3045 37.8207 32.8967 38.0038 32.446 38.0038H26.2531",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8625 42.7033L25.2273 42.3386C25.3823 42.1836 25.5865 42.0858 25.8043 42.0636L30.4047 41.5869",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.77 35.416L38.0408 30.4982C38.5999 29.8547 39.5515 29.7293 40.2576 30.206C40.3493 30.2675 40.4323 30.337 40.5074 30.412C41.0548 30.9595 41.168 31.8286 40.7387 32.5065L35.9481 40.0657C35.5422 40.7054 34.8661 41.1243 34.1114 41.2024L32.5422 41.3648",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9886 18.1391L30.4587 23.1324C30.1276 23.786 29.3606 24.0899 28.6718 23.8402C28.5828 23.808 28.499 23.7677 28.4209 23.7209C27.85 23.3792 27.5738 22.6781 27.7897 22.0233L30.1998 14.7195L32.9886 18.1391Z",
    fill: "#FED2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9888 18.1392L31.4824 21.112",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6036 15.5013L28.6052 15.4973C28.6162 15.4802 28.6273 15.4631 28.6383 15.4465L28.6036 15.5013Z",
    fill: "#FED2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5804 31.3707C33.435 31.3707 35.7491 29.0566 35.7491 26.202C35.7491 23.3473 33.435 21.0332 30.5804 21.0332C27.7258 21.0332 25.4116 23.3473 25.4116 26.202C25.4116 29.0566 27.7258 31.3707 30.5804 31.3707Z",
    fill: "#FFE177"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4521 31.2968C31.1685 31.3454 30.8775 31.3706 30.5804 31.3706C27.7257 31.3706 25.4116 29.0559 25.4116 26.2018C25.4116 23.347 27.7257 21.033 30.5804 21.033C30.8775 21.033 31.1685 21.0582 31.4521 21.1068C29.0125 21.5207 27.1555 23.6441 27.1555 26.2018C27.1555 28.7588 29.0125 30.8828 31.4521 31.2968Z",
    fill: "#FEC165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4832 21.4767H28.4838C29.1247 21.1919 29.8333 21.0332 30.5801 21.0332C30.8876 21.0332 31.1897 21.0603 31.4825 21.1119C32.3922 21.2719 33.2196 21.6698 33.8986 22.2394",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8469 28.2794C25.567 27.644 25.412 26.941 25.412 26.2022C25.412 25.0199 25.8087 23.9306 26.4768 23.0596",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5127 24.6538C35.6665 25.1428 35.7489 25.6626 35.7489 26.2021C35.7489 29.0562 33.4348 31.3703 30.5801 31.3703C29.2379 31.3703 28.0157 30.8591 27.0967 30.0195",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4979 24.1254C31.4098 24.052 30.9051 23.6714 30.1646 23.8945C29.4144 24.1204 29.2281 25.1469 29.7379 25.5468C30.0306 25.7764 30.4711 25.9651 31.0647 26.175C32.3933 26.6446 31.9022 28.5183 30.5507 28.5273C30.0233 28.5308 29.7768 28.4973 29.3135 28.1942",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5505 29.211V28.5271",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5505 23.8272V23.1929",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2237 20.8351L29.3407 14.3384C29.689 13.7887 30.2703 13.4282 30.9188 13.3611L38.0584 12.6211C38.2464 12.6016 38.4218 12.5185 38.5549 12.3853L38.6432 12.2969C38.7451 12.195 38.9103 12.195 39.0123 12.2969L42.6892 15.9738C42.8051 16.0897 42.7867 16.2824 42.6511 16.3744L39.3081 18.6406C39.1051 18.7781 39.0102 19.0289 39.0706 19.2668C39.1211 19.4632 39.1449 19.6613 39.1449 19.8576C39.1449 20.632 38.7661 21.3742 38.1055 21.8246L37.0732 22.5291L36.4081 23.8914C36.1147 24.4927 35.4523 24.8205 34.7967 24.6891C34.0855 24.5465 33.613 23.923 33.613 23.2469C33.613 23.0694 33.6451 22.8885 33.7144 22.7116L35.2487 18.776C35.4551 18.2468 35.0052 17.6937 34.445 17.7886L31.4695 18.2912C31.3031 18.3189 31.1517 18.4043 31.0407 18.5319L27.5416 22.5607C27.0613 23.1143 26.2436 23.2219 25.6362 22.812C25.5575 22.7593 25.4865 22.6999 25.4221 22.635C24.9519 22.1647 24.8548 21.4175 25.2237 20.8351Z",
    fill: "#FFE5C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9547 24.1878C34.4079 24.1073 34.8101 23.8167 35.0214 23.384L35.6859 22.0216L36.7187 21.3166C37.3788 20.8662 37.7582 20.124 37.7582 19.3496C37.7582 19.1533 37.7338 18.9552 37.6839 18.7594C37.6229 18.5209 37.7177 18.2707 37.9214 18.1326L42.0034 15.2881L42.6892 15.9739C42.8051 16.0898 42.7867 16.2825 42.6511 16.3744L39.3081 18.6407C39.1051 18.7787 39.0096 19.0289 39.0706 19.2669C39.1211 19.4633 39.1455 19.6613 39.1455 19.8577C39.1455 20.6326 38.7661 21.3737 38.1055 21.8252L37.0726 22.5291L36.4081 23.892C36.1147 24.4933 35.4529 24.8206 34.7967 24.6897C34.4501 24.6204 34.16 24.4363 33.9547 24.1878Z",
    fill: "#FED2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.643 12.2969L38.5551 12.3855C38.4216 12.5183 38.2463 12.602 38.0587 12.621L30.919 13.361C30.2701 13.4281 29.6888 13.7885 29.3406 14.3384L25.2236 20.8353C24.8546 21.4178 24.9518 22.1646 25.4223 22.6351C25.4863 22.7003 25.5577 22.7594 25.6364 22.8123C26.2435 23.222 27.0616 23.1143 27.542 22.5607L31.0408 18.5323C31.1515 18.4044 31.3035 18.3189 31.4695 18.2912L34.4449 17.7886C35.0052 17.6939 35.4549 18.2469 35.2488 18.7759L33.7147 22.712C33.6452 22.8886 33.6132 23.0694 33.6132 23.2472C33.6132 23.9232 34.0856 24.5469 34.7967 24.689C35.4524 24.8206 36.1149 24.4928 36.4083 23.8918L37.0733 22.5293L38.1054 21.825C38.7661 21.3741 39.145 20.6323 39.145 19.8579C39.145 19.6617 39.121 19.4636 39.0705 19.2668C39.0103 19.0293 39.105 18.7784 39.308 18.6406L40.0486 18.1386",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6511 16.3743L41.817 16.9396",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_548_2310",
    x: 0,
    y: 0,
    width: 63,
    height: 63,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_548_2310"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_548_2310",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_548_2310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.3291,
    height: 31.3291,
    fill: "white",
    transform: "translate(15.8354 11.8354)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotcomm);
export default __webpack_public_path__ + "static/media/totcomm.7e9a96438aba27f1e4eff26645a7f3fc.svg";
export { ForwardRef as ReactComponent };